import { useMemo } from 'react';

import { bereinigeHtml, hatMarkup } from '../domain/htmlSicher';

/**
 * Ein Prüfungstext, mit seiner Auszeichnung, wenn er welche trägt (Vorgabe des Nutzers,
 * 2026-10-02).
 *
 * Klartext wird ganz gewöhnlich als Text gesetzt — kein HTML-Weg, wo keiner nötig ist. Trägt
 * der Text Tags oder Entitäten, geht er durch `bereinigeHtml`: nur auszeichnende Tags, kein
 * Attribut. Erst danach darf er ins `innerHTML`.
 *
 * ⚠️ **Absätze werden inline.** Ein `<p>` am Anfang einer Checklistenzeile brächte sonst
 * Aussenabstände mit, die der Bogen nicht vorsieht (`.htmlText p` in `styles/global.css`).
 */
export function HtmlText({
  text,
  className,
  absaetze = false,
}: {
  text: string;
  className?: string;
  /** Absätze als Absätze — für längere Texte wie die Vignette. Sonst fliessen sie in der Zeile. */
  absaetze?: boolean;
}) {
  const html = useMemo(() => (hatMarkup(text) ? bereinigeHtml(text) : null), [text]);
  const klasse = ['htmlText', absaetze ? 'htmlAbsaetze' : '', className ?? ''].filter(Boolean).join(' ');
  const Tag = absaetze ? 'div' : 'span';
  if (html === null) return <Tag className={klasse}>{text}</Tag>;
  return <Tag className={klasse} dangerouslySetInnerHTML={{ __html: html }} />;
}
